module.exports = __webpack_public_path__ + "static/img/3-2-2.c5ea8cd2.jpg";